module.exports = __webpack_public_path__ + "static/John-Valiante-c2aaed4e243d616e0bea1ad02fbf8097.jpg";